/* Vitasy homepage "The daily treat": entrance animations + sticky bar. Safe to load more than once. */
(function(){
  if (window.__vtdt) return; window.__vtdt = true;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var hasIO = 'IntersectionObserver' in window;
  function onView(el, th, fn){ if(!el) return; if(reduce || !hasIO){ fn(true); return; }
    var io = new IntersectionObserver(function(e){ if(e[0].isIntersecting){ fn(false); io.disconnect(); } }, {threshold: th}); io.observe(el); }
  function restart(el, cls){ el.classList.remove(cls); void el.offsetWidth; el.classList.add(cls); }
  function init(root){
    root = root || document;
    // chapter 5 plates
    root.querySelectorAll('.vth .row5').forEach(function(r){ if(r.dataset.vt) return; r.dataset.vt=1;
      if(!reduce && hasIO) r.classList.add('ready');
      onView(r, .35, function(skip){ if(skip){ r.classList.remove('ready'); return; } restart(r,'play'); }); });
    // chapter 6 tiles + best sellers
    root.querySelectorAll('.vth .blk, .vth .bs-row').forEach(function(b){ if(b.dataset.vt) return; b.dataset.vt=1;
      onView(b, .2, function(skip){ b.classList.remove('wait'); if(!skip) restart(b,'play'); }); });
    // comparison rows + reviews
    root.querySelectorAll('.vth .ct7, .vth .rvg').forEach(function(el){ if(el.dataset.vt) return; el.dataset.vt=1;
      if(!reduce && hasIO) el.classList.add('wait');
      onView(el, .3, function(){ el.classList.remove('wait'); }); });
    // habit timeline
    root.querySelectorAll('.vth .tl7').forEach(function(el){ if(el.dataset.vt) return; el.dataset.vt=1;
      onView(el, .3, function(){ el.classList.add('on'); }); });
  }
  function sticky(){
    var bar = document.getElementById('vtSticky'); if(!bar) return;
    var hero = document.getElementById('hero'), foot = document.querySelector('footer');
    function upd(){
      var past = hero ? hero.getBoundingClientRect().bottom < 0 : window.scrollY > 600;
      var nearFoot = foot ? foot.getBoundingClientRect().top < window.innerHeight : false;
      var show = past && !nearFoot;
      bar.classList.toggle('is-on', show); bar.setAttribute('aria-hidden', show ? 'false' : 'true');
      var a = bar.querySelector('a'); if(a) a.tabIndex = show ? 0 : -1;
    }
    window.addEventListener('scroll', upd, {passive:true}); window.addEventListener('resize', upd); upd();
  }
  function boot(){ init(document); sticky(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function(e){ init(e.target); sticky(); });
})();
